// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"a8e5d6a6","258":"d02cd036","612":"7c69e4c3","884":"1e77e237","992":"06d1cb72"}[chunkId] + ".chunk.js";
};